export default __webpack_public_path__ + "static/3b)Laugh1-8090bebbd1780e473e91a907c93ecd8a.mp3";